import "./JobCard.css";
import { useState } from "react";
import ApplyJobModal from "./ApplyJobModal";


function JobCard({ job, onView }) {


  const [showApply, setShowApply] = useState(false);



  return (

<div className="job-card">

  {/* Header */}
  <div className="job-card-top">

    <div className="job-company-info">
      <h3>{job.title}</h3>

      <span>{job.company}</span>
    </div>

    <div className="job-package">
      ₹ {job.salary}
    </div>

  </div>

  {/* Job Info */}

  <div className="job-info">

    <p>📍 {job.location}</p>

    <p>💼 {job.type}</p>

    <p>🎓 {job.qualification}</p>

    <p>🧑‍💻 {job.experience}</p>

  </div>

  {/* Description */}

  <p className="job-desc">
    {job.description}
  </p>

  {/* Divider */}

  <div className="job-divider"></div>

  {/* Extra Details */}

  <div className="job-extra">

    <div className="job-tag job-vacancy">
      👥 {job.vacancies} Vacancies
    </div>

    <div className="job-tag job-deadline">
      📅 {job.deadline}
    </div>

    <div className="job-tag job-status">
      {job.status}
    </div>

  </div>

  {/* Buttons */}

  <div className="job-bottom">

    <button
      className="view-job-btn"
      onClick={() => onView(job)}
    >
      View Details
    </button>

    <button
      className="open-apply-btn"
      onClick={() => setShowApply(true)}
    >
      Apply Now
    </button>

  </div>

  <ApplyJobModal
    job={job}
    showModal={showApply}
    setShowModal={setShowApply}
  />

</div>

  );

}


export default JobCard;